import { render, staticRenderFns } from "./ajsc.vue?vue&type=template&id=87cf3e0e&scoped=true&"
import script from "./ajsc.vue?vue&type=script&lang=js&"
export * from "./ajsc.vue?vue&type=script&lang=js&"
import style0 from "./ajsc.vue?vue&type=style&index=0&id=87cf3e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cf3e0e",
  null
  
)

export default component.exports